import * as React from 'react';
import * as moment from 'moment';
import { IDonorRegistration } from '@nkr/models/donor-registration';
import { Col, Row } from "react-bootstrap";
import { cardBodyStyle, cardBodyTitleStyle, cardStyle, cardBodyTitleTextStyle } from '../../styles';

interface IProps {
    data: IDonorRegistration,
}

const DonorMentorInfo = ({ data }: IProps) => {
    return (
        <div id='donor-mentor-info' style={cardStyle}>
            <div style={cardBodyStyle}>
                <div style={cardBodyTitleStyle}>
                    <span style={cardBodyTitleTextStyle}>Donor Mentor</span>
                </div>
                <Row>
                    <Col xs={6} sm={2} md={4}>
                        <strong>Requested:</strong>
                    </Col>
                    <Col xs={6} sm={4} md={8}>
                        {moment(data.connectToDonorAcceptedDate).format('MM/DD/YYYY')}
                    </Col>

                </Row>
                <Row>
                    <Col xs={6} sm={2} md={4}>
                        <strong>Mentor:</strong>
                    </Col>
                    <Col xs={6} sm={4} md={8}>
                        {data.connectToDonorAssignedFirstName} {data.connectToDonorAssignedLastName}
                    </Col>
                </Row>
                <Row>
                    <Col xs={6} sm={2} md={4}>
                        <strong>Status:</strong>
                    </Col>
                    <Col xs={6} sm={4} md={8}>
                        {data.connectToDonorMilestone}
                    </Col>
                </Row>
            </div>
        </div>
    );
}

export default DonorMentorInfo;